<template>
	<div>
		<div class="form-row" :style="formStyle" style="margin-bottom: 1em">
			<div ref="stripe-card" />

			<v-alert
				type="error"
				:model-value="!!stripeError"
				transition="scale-transition"
				style="margin-top: 0.5em"
			>
				{{ stripeError }}
			</v-alert>
		</div>

		<v-progress-circular indeterminate v-if="loading" style="width: 100%" />

		<v-btn
			text
			@click="prevStep"
		>
			Back
		</v-btn>
		<v-btn
			color="primary"
			@click="nextStep"
			:disabled="loading"
			style="margin-left: 1em"
		>
			Continue
		</v-btn>
	</div>
</template>

<script>
export default {
	name: 'StripeForm',
	emits: ['prev-step', 'next-step'],
	data: function() {
		return {
			loading: true,
			stripeError: false
		};
	},
	computed: {
		formStyle: function() {
			if(this.loading) {
				return {
					display: 'none'
				};
			} else {
				return {};
			}
		}
	},
	methods: {
		nextStep: function() {
			this.loading = true;
			this.stripe.createToken(this.card).then((result) => {
				if(result.error) {
					this.loading = false;
					this.stripeError = result.error.message;
				} else {
					this.loading = false;

					this.$emit('next-step', () => {
						return this.getOrderData();
					});
				}
			});
		},
		prevStep: function() {
			this.$emit('prev-step');
		},
		getOrderData: function() {
			return new Promise((resolve, reject) => {
				this.stripe.createToken(this.card).then((result) => {
					if(result.error) {
						reject(result.error);
					} else {
						resolve({
							chargeToken: result.token.id
						});
					}
				}).catch((error) => {
					reject(error);
				});
			});
		}
	},
	mounted: function() {
		this.stripe = window.Stripe(this.$store.state.cart.merchantKey);
		let elements = this.stripe.elements();

		this.card = elements.create('card');

		// We are sometimes getting an issue with this never completing - hoping that auto retrying mounting the card in a couple of seconds will help
		let retryTimeout = window.setTimeout(() => {
			this.card.mount(this.$refs['stripe-card']);
		}, 2000);
		this.card.addEventListener('ready', () => {
			this.loading = false;
			window.clearTimeout(retryTimeout);
		});

		this.card.mount(this.$refs['stripe-card']);

		this.card.addEventListener('change', (result) => {
			if(result.error) {
				this.stripeError = result.error.message;
			} else {
				this.stripeError = false;
			}
		});
	}
};
</script>

<style scoped>
	.StripeElement {
		background-color: white;
		height: 40px;
		padding: 10px 12px;
		border-radius: 4px;
		border: 1px solid transparent;
		box-shadow: 0 1px 3px 0 #e6ebf1;
		-webkit-transition: box-shadow 150ms ease;
		transition: box-shadow 150ms ease;
	}

	.StripeElement--focus {
		box-shadow: 0 1px 3px 0 #cfd7df;
	}

	.StripeElement--invalid {
		border-color: rgb(var(--v-theme-error));;
	}

	.StripeElement--webkit-autofill {
		background-color: #fefde5 !important;
	}
</style>